module.exports = __webpack_public_path__ + "img/weekly-activity-head-long@2x.ee35ce7f.png";